module.exports = __webpack_public_path__ + "static/media/02FreshPreservesfinishedlabel.39f7bef8.webp";